import styled from 'styled-components';
import { darkgrey } from 'styles/Colors';
import { IWizardStepProps } from '../WizardStep';

export const StyledElement = styled.div<IWizardStepProps & { title: string }>`
  margin-right: 20px;
  position: relative;

  &:before {
    content: '${(props) => props.title}';
    position: absolute;
    top: 40px;
    left: 50%;
    transform: translate(-50%);
    white-space: nowrap;
    font-family: Lato;
    font-style: normal;
    font-weight: ${(props) => (props.step === props.currentStep ? 700 : 400)};
    font-size: 13px;
    line-height: 18.2px;
    color: ${darkgrey};
  }
`;
